/**
 * Entry point for the diagram system
 * Provides a unified API and backward compatibility with the global mermaidDiagramManager
 */
import { createDiagramSystem } from './diagram-system.js';

// Create the diagram system instance
const diagramSystem = createDiagramSystem();

// For backward compatibility, expose the diagram system as window.mermaidDiagramManager
if (typeof window !== 'undefined') {
  window.mermaidDiagramManager = diagramSystem;
}

// Export the diagram system for module usage
export default diagramSystem;

// Also export individual modules for direct access
export { createDiagramRenderer } from './diagram-renderer.js';
export { createPanZoomController } from './pan-zoom-controller.js';
export { createDiagramSystem } from './diagram-system.js';
export { resolveDependencies, createEventManager } from './dependency-resolver.js';